export const defaultUsers = [
  {
    name: "Amir Obè",
    slug: "amirobe",
    profilePictureUrl: "https://bonsai-profile-pictures.s3.amazonaws.com/de92c5e1-3171-48cf-bebc-c73e259837cd.png",
    bio: "Amir Obè Creative",
  },
  {
    name: "Coolie Cut",
    slug: "cooliecut",
    profilePictureUrl: "https://bonsai-profile-pictures.s3.amazonaws.com/d5982fa1-9c1a-44a1-a40e-fdc9d9574b2c.png",
    bio: "Hi I'm Cooliecut I'm from Florida and I make music :)",
  },
  {
    name: "Diarra Sylla",
    slug: "diarrasylla",
    profilePictureUrl: "https://bonsai-profile-pictures.s3.amazonaws.com/DiarraSylla.jpeg",
    bio: "I love food!!",
  },
  {
    name: "The Faim",
    slug: "thefaim",
    profilePictureUrl: "https://bonsai-profile-pictures.s3.amazonaws.com/139fc744-a3b7-4cc7-a4cf-a670b82a56d0.png",
    bio: "A couple of blokes from Australia who like music",
  },
]
